<template>
  <nav>
    <header class="flex">
      <h2 class="flex_fill m-0" style="font-size: 1rem">Phable</h2>
      <img src="/matt.jpeg" alt="Michael" style="width: 40px; height: 40px; border-radius: 40px;"/>
    </header>
    <loader v-if="loading"/>
    <ul class="navlist">
      <li v-for="project in projects">
        <router-link :to="{ path: '/project/'+project.id}" class="navlist--item" >
          <span>{{ project.Name}}</span>
        </router-link>
        <sub-nav-list v-bind:projectId="project.id"/>
      </li>
    </ul>
    <a href="#" class="button" @click="showModal = true"><span class="material-icons">add</span> Project</a>
    
    <modal v-if="showModal" @close="showModal = false" title="Add a project">
      <form @submit.prevent="addProject">
        <transition name="fade">
          <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
        </transition>
        <input-default label="Name" description="What's your project called" v-model="newProjectName"/>
        <input-default label="Description" v-model="newProjectDesc"/>
        <button class="button" type="submit">Add</button>
      </form>
    </modal>
  </nav>
</template>

<script>

  import InputDefault from '../form/InputDefault.vue'
  import AlertBar from '../form/Alert.vue'
  import Loader from '../ui/Loader.vue'
  import Modal from '../modal/Modal.vue'
  import SubNavList from '../lists/SubNavList.vue'
  import axios from 'axios'

  export default {
    components: {
      Modal,
      InputDefault,
      Loader,
      AlertBar,
      SubNavList
    },
    data: function() {
      return{
        msgtext: '',
        msgclass: 'error',
        error: '',
        newProjectName: '',
        newProjectDesc: '',
        showModal: false,
        search: '',
        projects: [],
        loading: true,
        token: JSON.parse(localStorage.getItem('user')).id,
        memberId: JSON.parse(localStorage.getItem('user')).userId
      }
    },
    methods: {
      addProject(){
        const data = {
          Name: this.newProjectName,
          Description: this.newProjectDesc
        }

        this.loading = true

        axios.post(process.env.VUE_APP_ROOT_API+'/members/'+this.memberId+'/projects?access_token='+this.token, data)
        .then(
          response => {
            this.addedProject = response.data
            //this.addMemberToProject(this.addedProject.id)
            this.getProjects()
            this.showModal = false
          },
          error => {
            this.msgtext = error,
            this.loading = false
          }
        )
      },
      getProjects(){
        var filter = {
            where: {
              Domain: {
                exists: false
              }
            }
        };

        var filters = JSON.stringify(filter);

        axios.get(process.env.VUE_APP_ROOT_API+'/members/'+this.memberId+'/projects?filter='+filters+'&access_token='+this.token)
        .then(response => {
          this.projects = response.data
          this.loading = false
        })
      }
    },
    mounted(){
      this.getProjects()
    }
  }

</script>

<style lang="scss">
  .navlist{
    margin-top: 50px !important;
  }

  .logo{
    height: 25px;
  }
</style>